import React, { useEffect, useState } from 'react';
import { Modal, Spinner, Table } from 'react-bootstrap';
import { format, parseISO } from 'date-fns';
import Avatar from '../../common/Avatar';
import SubtleBadge from '../../common/SubtleBadge';
import { documentHistory } from '../../../lib/api/player';

export const DocumentHistory = ({ player, onClose }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const playerName = [player?.name, player?.last_name].filter(Boolean).join(' ');

  useEffect(() => {
    const fetchData = async () => {
      if (!player?.player_guid) {
        return;
      }

      setLoading(true);
      try {
        const response = await documentHistory(player.player_guid);
        setItems(Array.isArray(response) ? response : response?.data || []);
      } catch (error) {
        console.error('Greska prilikom ucitavanja istorijata dokumenata:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [player]);

  const getFormattedDate = value => {
    if (!value) {
      return '-';
    }

    return format(typeof value === 'string' ? parseISO(value) : value, 'dd.MM.yyyy HH:mm');
  };

  return (
    <Modal show={!!player} onHide={onClose} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>
          Istorijat dokumenata{playerName ? ` - ${playerName}` : ''}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center">
            <Spinner animation="border" role="status" />
          </div>
        ) : (
          <Table responsive className="mb-0 align-middle">
            <thead>
              <tr>
                <th>ID</th>
                <th>Tip dokumenta</th>
                <th>Datum kreiranja</th>
                <th>Klub</th>
                <th>Korisnik</th>
                <th className="text-center">Status</th>
              </tr>
            </thead>
            <tbody>
              {items.length ? (
                items.map(item => (
                  <tr key={item.document_guid || item.document_id}>
                    <td>{item.document_id}</td>
                    <td>{item.documents_type_name}</td>
                    <td>{getFormattedDate(item.date_created)}</td>
                    <td>
                      <div className="d-flex align-items-center">
                        {item.image_path && (
                          <Avatar
                            src={`${process.env.REACT_APP_BASE_API_URL}/uploads/${item.image_path}`}
                            size="l"
                            name={item.short_name_club}
                          />
                        )}
                        <div className="ms-2">{item.name_club || item.short_name_club || '-'}</div>
                      </div>
                    </td>
                    <td>{item.user_name || '-'}</td>
                    <td className="text-center">
                      <SubtleBadge bg={item.color || 'secondary'} className="fs-10">
                        {item.status_name || '-'}
                      </SubtleBadge>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6} className="text-center">
                    Nema podataka
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        )}
      </Modal.Body>
    </Modal>
  );
};
